module.exports = __webpack_public_path__ + "img/logo-lion.dae77d5e.svg";